module.exports = __webpack_public_path__ + "static/sp_900x330-360da7954f3d9b42c46075c1082943b8.png";